import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Table, Divider } from 'semantic-ui-react';
import get from 'lodash.get';

import SprayProductTypesDropdown from 'components/SprayProductTypesDropdown';
import SprayProductsDropdown from 'components/SprayProductsDropdown';
import { Field } from 'react-final-form';
import { validators } from 'forms';
import { Product, ProductId } from 'services/products/types';
import { FieldArray } from 'react-final-form-arrays';
import classnames from 'classnames';
import ButtonLink from 'components/ButtonLink';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import FieldValues from 'components/FieldValues';
import { SprayProduct } from 'services/sprayEvents/types';
import { makeSelectSprayEventMultipleOperatorsTabActiveIndex } from 'services/sprayEventMultipleOperatorsTab/selectors';
import { setSprayEventMultipleOperatorsTabIndex } from 'services/sprayEventMultipleOperatorsTab/actions';
import ProductsTableRow from './components/ProductsTableRow';

import ProductRateField from './components/ProductRateField';
import ProductUnitsPerAreaField from './components/ProductUnitsPerAreaField';
import ProductRatePerUnitTypeDropdown from './components/ProductRatePerUnitTypeDropdown';
import ProductMinimumTreeAgeMessage from './components/ProductMinimumTreeAgeMessage';
import ProductDetailsWrapper from './components/ProductDetailsWrapper';

const {
    isRequired,
    isNumber,
    isPositiveNumber,
    composeValidators,
    maxValue1000000
} = validators;

export default function ProductPage(): React.ReactElement {
    const [selectedRow, setSelectedRow] = React.useState(0);
    const dispatch = useDispatch();

    const tabActiveIndex = useSelector(
        makeSelectSprayEventMultipleOperatorsTabActiveIndex()
    );

    React.useEffect(() => {
        return () => {
            dispatch(setSprayEventMultipleOperatorsTabIndex(0));
        };
    });

    const validateSprayProducts = (
        values: Record<string, any>
    ): Record<string, string>[] => {
        const ids: ProductId[] = [];
        const errors: Record<string, string>[] = [];

        values?.forEach((product: SprayProduct, index: number) => {
            const { id } = product;

            if (ids.includes(id)) {
                errors[index] = {
                    id: 'This product has already been used in the spray'
                };
            } else {
                ids.push(id);
            }
        });

        return errors;
    };

    return (
        <div className="spray-event-modal-step || product-page">
            <FieldArray name="sprayProducts" validate={validateSprayProducts}>
                {({ fields, meta }) => {
                    const { error, submitFailed }: any = meta;
                    return (
                        <React.Fragment>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width="8">
                                        <h4>Product list</h4>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width="16">
                                        <Field
                                            name="sprayProducts"
                                            subscription={{ value: true }}
                                        >
                                            {({
                                                input: { value }
                                            }): React.ReactElement => (
                                                <ResponsiveTable>
                                                    <Table
                                                        selectable
                                                        singleLine
                                                        single
                                                        unstackable
                                                        size="small"
                                                    >
                                                        <Table.Body>
                                                            {value &&
                                                                value.map(
                                                                    (
                                                                        product: Product,
                                                                        index: number
                                                                    ) => {
                                                                        const invalid =
                                                                            submitFailed &&
                                                                            error &&
                                                                            error[
                                                                                index
                                                                            ];

                                                                        return (
                                                                            <ProductsTableRow
                                                                                invalid={
                                                                                    invalid
                                                                                }
                                                                                productId={
                                                                                    product.id
                                                                                }
                                                                                index={
                                                                                    index +
                                                                                    1
                                                                                }
                                                                                key={
                                                                                    `${index}-${product.id}` // eslint-disable-line react/no-array-index-key
                                                                                }
                                                                                handleRowClick={(): void =>
                                                                                    setSelectedRow(
                                                                                        index
                                                                                    )
                                                                                }
                                                                                handleOnDeleteRowClick={(
                                                                                    event
                                                                                ): void => {
                                                                                    event.stopPropagation();

                                                                                    const lastOneSelected =
                                                                                        fields
                                                                                            .value
                                                                                            .length -
                                                                                            1 ===
                                                                                        selectedRow;

                                                                                    fields.remove(
                                                                                        index
                                                                                    );

                                                                                    if (
                                                                                        lastOneSelected &&
                                                                                        selectedRow !==
                                                                                            0
                                                                                    ) {
                                                                                        setSelectedRow(
                                                                                            selectedRow -
                                                                                                1
                                                                                        );
                                                                                    } else if (
                                                                                        selectedRow ===
                                                                                            index &&
                                                                                        index !==
                                                                                            0
                                                                                    ) {
                                                                                        setSelectedRow(
                                                                                            index -
                                                                                                1
                                                                                        );
                                                                                    }
                                                                                }}
                                                                                handleOnSortingUpClick={(
                                                                                    event
                                                                                ): void => {
                                                                                    event.stopPropagation();

                                                                                    if (
                                                                                        index >
                                                                                        0
                                                                                    ) {
                                                                                        fields.move(
                                                                                            index,
                                                                                            index -
                                                                                                1
                                                                                        );
                                                                                    }
                                                                                }}
                                                                                handleOnSortingDownClick={(
                                                                                    event
                                                                                ): void => {
                                                                                    event.stopPropagation();

                                                                                    if (
                                                                                        index <
                                                                                        value.length -
                                                                                            1
                                                                                    ) {
                                                                                        fields.move(
                                                                                            index,
                                                                                            index +
                                                                                                1
                                                                                        );
                                                                                    }
                                                                                }}
                                                                                displayActions={
                                                                                    value.length >
                                                                                    1
                                                                                }
                                                                                displayErrors={
                                                                                    submitFailed &&
                                                                                    error
                                                                                }
                                                                            />
                                                                        );
                                                                    }
                                                                )}
                                                        </Table.Body>
                                                    </Table>
                                                </ResponsiveTable>
                                            )}
                                        </Field>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width="16" textAlign="center">
                                        <ButtonLink
                                            classNames="new-product-button"
                                            buttonProps={{
                                                primary: true,
                                                type: 'button'
                                            }}
                                            onClick={(): void => {
                                                fields.push({
                                                    sprayProductTypeId: null,
                                                    productId: null
                                                });

                                                fields.length &&
                                                    setSelectedRow(
                                                        fields.length
                                                    );
                                            }}
                                        >
                                            + Add new product
                                        </ButtonLink>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Divider />
                            <FieldValues
                                fieldNames={[
                                    'sprayProducts',
                                    'sprayEntityIds',
                                    'sprayApplicationRate',
                                    'sprayEquipmentSetId',
                                    'startDate',
                                    'applicationType',
                                    'sprayEventOperations'
                                ]}
                            >
                                {({
                                    sprayProducts,
                                    sprayEntityIds,
                                    sprayApplicationRate,
                                    sprayEquipmentSetId,
                                    startDate,
                                    applicationType,
                                    sprayEventOperations
                                }): any => {
                                    const product = get(
                                        sprayProducts,
                                        selectedRow
                                    ) as SprayProduct;

                                    const { id, units, perUnitType } = product;

                                    return fields.map(
                                        (
                                            name: string,
                                            index: number
                                        ): React.ReactElement | null => {
                                            const productsFormsClass =
                                                classnames(
                                                    'product-page-form',
                                                    {
                                                        hidden:
                                                            selectedRow !==
                                                            index
                                                    }
                                                );

                                            return (
                                                <Grid
                                                    key={
                                                        sprayProducts[index].id
                                                    }
                                                    className={
                                                        productsFormsClass
                                                    }
                                                >
                                                    <Grid.Row>
                                                        <Grid.Column width="8">
                                                            <h4>{`Product ${
                                                                index + 1
                                                            }`}</h4>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row>
                                                        <Grid.Column width="8">
                                                            <SprayProductTypesDropdown
                                                                name={`${name}.typeId`}
                                                            />
                                                        </Grid.Column>
                                                        <Grid.Column width="8">
                                                            <Field
                                                                name={`${name}.typeId`}
                                                                subscription={{
                                                                    value: true
                                                                }}
                                                            >
                                                                {({
                                                                    input: {
                                                                        value
                                                                    }
                                                                }): React.ReactElement => (
                                                                    <SprayProductsDropdown
                                                                        name={`${name}.id`}
                                                                        sprayProductTypeId={
                                                                            value
                                                                        }
                                                                        validate={
                                                                            isRequired
                                                                        }
                                                                    />
                                                                )}
                                                            </Field>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row>
                                                        <Grid.Column
                                                            computer="4"
                                                            mobile="4"
                                                        >
                                                            <ProductUnitsPerAreaField
                                                                name={name}
                                                                validate={composeValidators(
                                                                    isRequired,
                                                                    isNumber,
                                                                    isPositiveNumber,
                                                                    maxValue1000000
                                                                )}
                                                            />
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            computer="4"
                                                            mobile="6"
                                                        >
                                                            <ProductRatePerUnitTypeDropdown
                                                                name={`${name}.perUnitType`}
                                                                productId={id}
                                                            />
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            computer="4"
                                                            mobile="6"
                                                        >
                                                            <ProductRateField
                                                                perUnitType={
                                                                    perUnitType
                                                                }
                                                                productId={id}
                                                                units={units}
                                                                applicationRate={
                                                                    sprayApplicationRate
                                                                }
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row>
                                                        <Grid.Column>
                                                            {product && (
                                                                <ProductDetailsWrapper
                                                                    applicationType={
                                                                        applicationType
                                                                    }
                                                                    tabActiveIndex={
                                                                        tabActiveIndex
                                                                    }
                                                                    product={
                                                                        product
                                                                    }
                                                                    orderIntoTank={
                                                                        selectedRow
                                                                    }
                                                                    entityIds={
                                                                        sprayEntityIds
                                                                    }
                                                                    applicationRate={
                                                                        sprayApplicationRate
                                                                    }
                                                                    sprayEventOperations={
                                                                        sprayEventOperations
                                                                    }
                                                                />
                                                            )}
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <ProductMinimumTreeAgeMessage
                                                        entityIds={
                                                            sprayEntityIds
                                                        }
                                                        productId={product.id}
                                                        date={startDate}
                                                    />
                                                </Grid>
                                            );
                                        }
                                    );
                                }}
                            </FieldValues>
                        </React.Fragment>
                    );
                }}
            </FieldArray>
        </div>
    );
}
